import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { UserPermissionsService } from './user-permissions.service';
import { GlobalVariablesService } from './global-variables.service';
import { NotificationsService } from './notifications.service';
import { ParseApiService } from './parse-api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InitializeGlobalVariableService {

  constructor(
    private userService: UserService,
    private notificationsService: NotificationsService,
    private userPermissionService: UserPermissionsService,
    private globalVariablesService: GlobalVariablesService,
    private parseApiService: ParseApiService

  ) {


  }

  logging() {
    const forceProduction = environment.forceProductionKey == true
    this.parseApiService.connectToServer(forceProduction);
    this.userService.invalidSessionTokenTest();
  }
  initializeGlobalVariable() {
    if (!window.location.href.includes('anonymous-action')) {
      this.logging()
      this.userService.getUserProjects();
      this.userService.getUserRoles();
      this.notificationsService.initChangeProjectNotificationsNotReadedInProject();
      this.userPermissionService.initChangePermissionInProject()
      this.globalVariablesService.fecthCurrentProject();
      this.globalVariablesService.updateSensorDataType$().subscribe();
      this.globalVariablesService.updateSensorModels$().subscribe();
    }
    return true
  }
  destroyGlobalVariable() {
    this.userPermissionService.destroyChangePermissionInProject()
    this.notificationsService.destroyChangeProjectNotificationsNotReadedInProject()
  }
}
